window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.ce-tabs-item').length) {
    import('./_tabs.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
